import React from 'react';
import Hero from '../components/home/Hero';
import WordOfTheDayFeature from '../components/home/WordOfTheDayFeature';
import WordChallenge from '../components/home/WordChallenge';
import CategoryExplorer from '../components/home/CategoryExplorer';
import WordsWorthKnowing from '../components/home/WordsWorthKnowing';
import AskNaturally from '../components/home/AskNaturally';
import YourWords from '../components/home/YourWords';
import { usePageMeta, SITE_NAME } from '../lib/usePageMeta';

const HomePage = () => {
  usePageMeta(
    `Definition of the Word – Define Any English Word | ${SITE_NAME}`,
    'Definition of the word you’re looking for: meaning, pronunciation, examples and similar words. Define any English word in one search.'
  );

  return (
    <>
      <Hero />
      <WordOfTheDayFeature />
      <WordChallenge />
      <CategoryExplorer />
      <WordsWorthKnowing />
      <AskNaturally />
      <YourWords />
    </>
  );
};

export default HomePage;
